<template>
  <div class="applytrial">
    <div class="textarea">
      <textarea class="f15" v-model="textinput" name="" id="afterEval" placeholder="说些什么吧~(此内容将由官方筛选后显示，对所有人可见)"></textarea>
      <p class="f13">{{textNum}}/140</p>
    </div>
    <div class="integral flex-js-ac">
      <p class="f14">抵扣试用币</p>
      <span class="f14 color-FC0324" v-if="$route.query.integral">{{$route.query.integral}}个金币</span>
    </div>
    <div class="box">
      <div class="integral select flex-js-ac" @click="selectage">
        <p class="f16">选择年龄</p>
        <span class="f12 flex-ac">{{age ? age : '请选择'}}<van-icon name="arrow" size="0.08rem" color="#1D1E1E"/></span>
      </div>
      <div class="integral select flex-js-ac" @click="selectskin">
        <p class="f16">选择肤质</p>
        <span class="f12 flex-ac">{{skin ? skin : '请选择'}}<van-icon name="arrow" size="0.08rem" color="#1D1E1E"/></span>
      </div>
      <div class="integral select flex-js-ac" @click="selectsex">
        <p class="f16">选择性别</p>
        <span class="f12 flex-ac">{{sex ? sex : '请选择'}}<van-icon name="arrow" size="0.08rem" color="#1D1E1E"/></span>
      </div>
    </div>
    <div class="footer footerIOS flex-ac">
      <button class="f13" @click="$router.go(-1)">再考虑下</button>
      <button class="f13 yellow flex-1" @click="submit">申请试用（消耗{{$route.query.integral ? $route.query.integral : 0}}个金币）</button>
    </div>
    <awesome-picker
      ref="picker"
      :textTitle="picker.textTitle"
      :data="picker.data"
      :anchor="picker.anchor"
      @confirm="handlePickerConfirmGender">
    </awesome-picker>
  </div>
</template>

<script>
export default {
  name: 'applytrial',
  data () {
    return {
      textinput: '',
      age: '',
      skin: '',
      sex: '',
      picker: {
        type: -1,
        anchor: [],
        textTitle: '选择器',
        data: []
      },
      ageAnchor: null,
      skinAnchor: null,
      sexAnchor: null,
      textNum: 0
    }
  },
  watch: {
    textinput (n) {
      if (n.length > 140) {
        this.textNum = 140
      } else {
        this.textNum = n.length
      }
      this.textinput = this.textinput.slice(0, 140)
      console.log(n.length)
    }
  },
  methods: {
    selectage () {
      var age = ['请选择', '14岁以下', '14~18', '19~24', '25~28', '29~40', '41以上']
      this.picker.textTitle = '选择年龄'
      this.picker.type = 0
      this.picker.anchor = this.ageAnchor ? this.ageAnchor : []
      this.picker.data = [age]
      this.$nextTick(() => {
        this.$refs.picker.show()
      })
    },
    selectskin () {
      var skin = ['请选择', ' 中性', '油性', '干性', '混合偏干', '混合偏油', '敏感肌']
      this.picker.textTitle = '选择肤质'
      this.picker.type = 1
      this.picker.anchor = this.skinAnchor ? this.skinAnchor : []
      this.picker.data = [skin]
      this.$nextTick(() => {
        this.$refs.picker.show()
      })
    },
    selectsex () {
      var sex = ['请选择', '男', '女']
      this.picker.textTitle = '选择性别'
      this.picker.type = 2
      this.picker.anchor = this.sexAnchor ? this.sexAnchor : []
      this.picker.data = [sex]
      this.$nextTick(() => {
        this.$refs.picker.show()
      })
    },
    handlePickerConfirmGender (v) {
      if (v[0].value == '请选择') return
      if (this.picker.type == 0) {
        this.ageAnchor = v
        this.age = v[0].value
      } else if (this.picker.type == 1) {
        this.skinAnchor = v
        this.skin = v[0].value
      } else if (this.picker.type == 2) {
        this.sexAnchor = v
        this.sex = v[0].value
      }
    },
    submit () {
      if (this.textinput.trim() == '') {
        this.$toast('申请理由不能为空')
        return
      }
      this.$toast.loading({
        duration: 0,
        message: '正在提交...',
        forbidClick: true
      })
      this.$ckeckgraphic({
        content: this.textinput,
        callback: () => {
          var url = 'Wxmall/NewItem/addApply',
            data = {
              actid: this.$route.query.actid,
              content: this.textinput.trim(),
              age: this.age,
              skintype: this.skin,
              sex: this.sex,
              skuid: this.$route.query.skuid
            }
          this.$customRequestAjax.post(url, data).then(res => {
            if (res.data.code == 200) {
              this.$toast(res.data.msg)
              setTimeout(() => {
                this.$router.replace('/submitresult')
              }, 100)
            }else {
              setTimeout(() => {
                this.$router.replace('/submitresult')
              }, 100)
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.applytrial {
  margin: 0.1rem 0.11rem;
  .textarea {
    background: #ffffff;
    border-radius: 0.03rem;
    padding: 0.15rem;
    position: relative;
    textarea {
      width: 100%;
      height: 1.91rem;
      border-width: 0;
      display: block;
      &::placeholder {
        font-size: 0.15rem;
        color: #B0B0B0;
      }
    }
    p {
      position: absolute;
      right: 0.1rem;
      bottom: 0.08rem;
      color: #B0B0B0;
    }
  }
  .integral {
    background: #ffffff;
    border-radius: 0.04rem;
    height: 0.5rem;
    margin: 0.1rem 0;
    padding: 0 0.15rem;
    p {
      color: #222222;
    }
    span {

    }
  }
  .select {
    margin: 0;
    position: relative;
    &:after {
      content: '';
      height: 0.01rem;
      background: #F5F5F5;
      position: absolute;
      left: 0.1rem;
      right: 0.1rem;
      bottom: 0;
    }
    span {
      color: #979797;
    }
  }
  .box {
    background: #ffffff;
    border-radius: 0.04rem;
  }
  .footer {
    background: #ffffff;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    button {
      height: 0.49rem;
      background: #ffffff;
      font-weight: bold;
      border-width: 0;
      outline: none;
      color: #292929;
      padding: 0 0.4rem;
      &.yellow {
        color: #ffffff;
        background: linear-gradient(90deg, #FFA700 0%, #FFBA00 100%);
        border-radius: 0.2rem 0 0 0;
        padding: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newproducttrial/applytrial.vue